module.exports = __webpack_public_path__ + "img/tu2.6a3fc11b.png";